<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app',

  computed: mapGetters(['isLogged']),

  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
  },

  created() {
    let user = localStorage.getItem('user');

    if (user) {
      user = JSON.parse(user);
      this.$store.commit('setUserData', user);
    }
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: 'MyriadPro';
  font-display: swap;
  font-weight: normal;
  font-style: normal;
  src: url('assets/fonts/MyriadPro.ttf');
}

@font-face {
  font-family: 'MyriadPro';
  font-display: swap;
  font-weight: bold;
  font-style: normal;
  src: url('assets/fonts/MyriadProBold.otf');
}

@font-face {
  font-family: 'MyriadPro';
  font-display: swap;
  font-weight: 500;
  font-style: normal;
  src: url('assets/fonts/MyriadProSemibold.otf');
}

body {
  font-family: 'MyriadPro';
  margin: 0;
}

* {
  box-sizing: border-box;
}

.chev-down {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid white;
  transition: transform 200ms ease-in-out;
}
</style>
